export enum SessionEvent {
    TokenMaxLifetimeReached = "tokenMaxLifetimeReached",
    TokenAutoUpdateFailed = "tokenAutoUpdateFailed"
}





export interface SessionEventsType {
    tokenMaxLifetimeReached: (newTokenDateExpired: Date) => void;
    tokenAutoUpdateFailed: () => void;
    [key: string]: (...args: any[]) => void;
}
